import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { closeAuthModal } from 'modules/auth';

const FinalStep: React.FC = () => {
  const t = useTranslations();
  const isRequired = useAppSelector(state => state.authModal.isRequired);
  const isContinuing = useAppSelector(state => state.authModal.continue);

  const dispatch = useAppDispatch();

  return (
    <div className="w-full">
      <div className="flex items-center justify-center">
        <Image src="/images/tick.webp" alt="tick" width={257} height={257} title="Ro'yxatdan o'tingiz" loading="lazy" />
      </div>
      <h2 className="mb-4 text-center text-2xl font-semibold">{t('auth.last_step_title')} 🎉</h2>
      <p className="mb-4 text-center text-gray-600">{t('auth.last_step_desc')}</p>
      {isRequired || isContinuing ? (
        <button onClick={() => dispatch(closeAuthModal())} className="w-full rounded-md bg-green-500 py-2 text-white">
          {t('davom_ettirish')}
        </button>
      ) : (
        <Link href="/">
          <button onClick={() => dispatch(closeAuthModal())} className="w-full rounded-md bg-green-500 py-2 text-white">
            {t('auth.last_step_button')}
          </button>
        </Link>
      )}
    </div>
  );
};

export default FinalStep;
